import React from "react";
import Banner from "../../Assets/About/CommonBg.jpg";

const SimpleBanner = ({
  backgroundImage = Banner,
  title = "",
  subheading = "",
}) => {

  return (
    <div className="relative w-full h-[200px] md:h-[250px] lg:h-[300px] overflow-hidden">
      {/* Background Media */}
        <img
          src={backgroundImage}
          alt="Main Banner"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />


      {/* Dark Overlay for readability */}
      <div className="absolute inset-0 bg-orange-300/60"></div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full px-4 sm:px-6 text-center mt-10">
        <div className="w-auto">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-jakarta font-bold text-white leading-tight">
            {title}
          </h1>

          {/* {subheading && (
           <p className="inline-block mt-3 md:mt-6 text-sm sm:text-base md:text-lg text-white font-semibold tracking-wide bg-orange-700 rounded-full px-6 py-2">
             {subheading}
            </p>

          )} */}
        </div>
      </div>
    </div>
  );
};

export default SimpleBanner;
